/**
 * `approvals` namespace — Korean translations.
 *
 * Mirrors `en/approvals.ts` exactly; the `Record<ApprovalsKey, string>` annotation
 * makes a missing or misspelled key a compile error. Approve→승인, Reject→거부,
 * Expired→만료됨 per the glossary; BUY/SELL·MARKET/LIMIT localize to 매수·매도 /
 * 시장가·지정가.
 */
import type { ApprovalsKey } from "../en/approvals";

export const approvals: Record<ApprovalsKey, string> = {
  eyebrow: "사람 확인",
  title: "승인",
  description: "결정을 기다리는 주문과 각 주문의 마감 시각 및 타임아웃 동작을 표시합니다.",

  loadError: "승인을 불러오지 못했습니다. 다시 시도해 주세요.",
  emptyTitle: "대기 중인 승인 없음",
  emptyDescription: "승인 필요 전략이 매매를 제안하면 여기(및 푸시)에 표시됩니다.",

  expired: "만료됨",
  timeLeft: "{time} 남음",
  durationHm: "{h}시간 {m}분",
  durationMs: "{m}분 {s}초",
  durationS: "{s}초",

  onTimeoutLabel: "타임아웃 시:",
  autoApprove: "자동 승인",
  cancelTimeout: "취소",

  highValueNote: "고액 주문 — 모드와 무관하게 승인을 거쳐 처리됩니다 (§4.4).",

  tokenLabel: "승인 토큰",
  tokenPlaceholder: "알림에서 받은 토큰을 붙여넣으세요",
  tokenHint: "승인 푸시 / 알림에 담긴 일회용 토큰입니다.",
  confirmApprove: "승인 확인",

  approve: "승인…",
  reject: "거부",

  tokenRejected: "토큰이 승인되지 않았습니다. 확인 후 다시 시도해 주세요.",
  rejectError: "거부하지 못했습니다. 다시 시도해 주세요.",

  shares: "{qty}주",
  sideBuy: "매수",
  sideSell: "매도",
  typeMarket: "시장가",
  typeLimit: "지정가",
};
